namespace RedBullMOBILE360.Sms {
    export interface SubscriptionCodesRow {
        OfferId?: string;
        OfferName?: string;
        IsPrimary?: number;
        SubscriptionCode?: string;
        UnsubscriptionCode?: string;
        IsActive?: number;
        StopAtrnwCode?: string;
        Eligibility?: number[];
    }

    export namespace SubscriptionCodesRow {
        export const idProperty = 'OfferId';
        export const nameProperty = 'OfferId';
        export const localTextPrefix = 'Sms.SubscriptionCodes';
        export const deletePermission = 'Sms:SubscriptionCodes';
        export const insertPermission = 'Sms:SubscriptionCodes';
        export const readPermission = 'Sms:SubscriptionCodes';
        export const updatePermission = 'Sms:SubscriptionCodes';

        export declare const enum Fields {
            OfferId = "OfferId",
            OfferName = "OfferName",
            IsPrimary = "IsPrimary",
            SubscriptionCode = "SubscriptionCode",
            UnsubscriptionCode = "UnsubscriptionCode",
            IsActive = "IsActive",
            StopAtrnwCode = "StopAtrnwCode",
            Eligibility = "Eligibility"
        }
    }
}
